<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
     <!-- <a class="logo" href="#">Dinuda<span> Resort</span></a> -->
    
      <img *ngIf="currentTheme==='default'" src="assets/images/logo.png" width="300px" height="60px"   alt="">
      <img *ngIf="currentTheme==='dark'" src="assets/images/logo.png" width="300px" height="60px"  alt="">
  </div>
</div>


<div class="header-container">
  <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="username"
               nbContextMenuTag="my-context-menu"
               [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
